const my_profile = {
  viewMyClubSeacretProfile: "Mein ClubSeacret-Profil anzeigen", // translated
  verifiedEmail: "Verifizierte E-Mail", // translated
  unverifiedEmail: "unverifizierte Email", // translated
  viewMoreDetails: "Weitere Details anzeigen", // translated
};

export default my_profile;
